import React, { useState, useEffect } from "react";
import user from "../assets/user.png";
import user_selected from "../assets/user_selected.png";
import logedInUser from "../assets/LogedinUserIcon.png";
import logedInUser_selected from "../assets/selectedProfileGuest.png";
import search from "../assets/search.png";
import search_selected from "../assets/selectedSearchIcon.png";
import live from "../assets/live.png";
import live_selected from "../assets/selectedLiveIcon.png";
import home from "../assets/home.png";
import home_selected from "../assets/selectedhomeIcon.png";
import watchlist from "../assets/watchlist.png";
import watchlist_selected from "../assets/selectedWatchlist.png";
import categories from "../assets/categories.png";
import categories_selected from "../assets/selectedCategoriesIcon.png";
import settings from "../assets/settings.png";
import settings_selected from "../assets/selectedSettingsIcon.png";
import logout from "../assets/logout.png";
import radio_tv from "../assets/radio_tv.png";
import radio_tv_active from "../assets/radio_tv_active.png";
import logout_selected from "../assets/selectedLogoutIcon.png";
import menulogo from "../assets/menulogo.png";
import side_menu from "../assets/Side_Menu.png";
import { fetchContent } from "../services/api";
import { Translate } from "./LanguageChanger";
import Wrapper from "./shared/Wrapper";

let totalNumberofMenu = 9;
let prevSelectedMenuIndex = 4;
let selectedMenuIndex = 4;
let addFocus;
let SetFocusTodefault;
let currentScreen = "Home";
let resolution =
  window.innerWidth >= 1920 && window.innerHeight >= 1080 ? "FHD" : "HD";
const userAgent = navigator.userAgent.toLowerCase();
if (
  userAgent.includes("webos") ||
  userAgent.includes("lg") ||
  userAgent.includes("web0s")
) {
  resolution = "FHD";
}
// console.log("resolution is --------- = ", resolution, userAgent);
const changeImageBgColor = (imgSrc, R, G, B, callback) => {
  const img = new Image();
  img.src = imgSrc;
  img.crossOrigin = "Anonymous";
  img.onload = () => {
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);

    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;

    for (let i = 0; i < data.length; i += 4) {
      if (data[i + 3] > 0) {
        // If alpha channel is not 0 (not transparent)
        data[i] = R; //255; // Red value
        data[i + 1] = G; //103; // Green value
        data[i + 2] = B; //31; // Blue value
      }
    }

    ctx.putImageData(imageData, 0, 0);
    callback(canvas.toDataURL());
  };
};

const MenuScreen = ({
  navigate,
  handleMenuselection,
  shouldCloseMenu = true,
  handleRightButton,
  isLogedIn,
  appNavigate,
  handleLogin,
  handleLogout,
  handleExit,
}) => {
  // console.log("isLogedIn....", isLogedIn)
  // const userProfile =JSON.parse(localStorage.getItem("myProfile"));
  // const profile_image = JSON.parse(localStorage.getItem("myProfile")).image;
  const profile = JSON.parse(localStorage.getItem("myProfile")) || {};
  //  const profile = JSON.parse(localStorage.getItem("user_details"))?.user_profiles?.[0] || {};
 
  const profile_image = (profile?.image !== null && profile?.image !== undefined)
    ? profile?.image
    : localStorage.getItem("proImg");
  // const profile_image = profile.image !== "null" || "undefined" : localStorage.getItem("proImg");

  // const profile_image = (profile.image !== null && profile.image !== undefined) 
  //   ? profile.image 
  //   : localStorage.getItem("proImg");

  console.log("profile_image...", profile_image);
  const menuItems = [
    {
      id: 1,
      menuName: isLogedIn ? "Profile" : "Login",
      name: isLogedIn ? <Translate langKey={"My-Profile"} /> : <Translate langKey={"Login"} />,
      icon: isLogedIn ? profile_image : user,
      selectedIcon: isLogedIn ? profile_image : user_selected,
    },
    {
      id: 2,
      menuName: "Search",
      name: <Translate langKey={"Search_"} />,
      icon: search,
      selectedIcon: search_selected,
    },
    {
      id: 3,
      menuName: "Live",
      name: <Translate langKey={"Live_"} />,
      icon: radio_tv,
      selectedIcon: radio_tv_active,
    },
    {
      id: 4,
      menuName: "LiveEvents",
      name: <Translate langKey={"Live_Events"} />,
      icon: live,
      selectedIcon: live_selected,
    },
    {
      id: 5,
      menuName: "Home",
      name: <Translate langKey={"Home_"} />,
      icon: home,
      selectedIcon: home_selected,
    },
    // isLogedIn
    // ?
    {
      id: 6,
      menuName: "Watchlist",
      name: <Translate langKey={"Watchlist"} />,
      icon: watchlist,
      selectedIcon: watchlist_selected,
    },
    // : {},
    {
      id: 7,
      menuName: "Categories",
      name: <Translate langKey={"category_name"} />,
      icon: categories,
      selectedIcon: categories_selected,
    },
    {
      id: 8,
      menuName: "Settings",
      name: <Translate langKey={"settings"} />,
      icon: settings,
      selectedIcon: settings_selected,
    },
    isLogedIn
      ? {
          id: 9,
          menuName: "Logout",
          name: <Translate langKey={"logout"} />,
          icon: logout,
          selectedIcon: logout_selected,
        }
      : {},
  ];
  const [state, setState] = useState({ rerender: false });
  const [menustate, setMenuState] = useState(shouldCloseMenu);
  const usericon = isLogedIn ? logedInUser_selected : user_selected;
  const [zindx, setZindx] = useState(10);
  const [images, setImages] = useState({
    usericon,
    search_selected,
    live_selected,
    home_selected,
    watchlist_selected,
    categories_selected,
    settings_selected,
    logout_selected,
  });
  const { rerender } = state;
  const [hoveredItemId, setHoveredItemId] = useState(null)
  const forceUpdate = () => setState(prevState => ({ ...prevState, rerender: !prevState.rerender }));
  const handleKeyDown = (event) => {
    if (event.keyCode !== undefined) {
      switch (event.keyCode) {
        case 38: // Up arrow
          selectedMenuIndex = Math.max(1, selectedMenuIndex - 1);
          forceUpdate();
          // setState({ rerender: !rerender });
          break;
        case 40: // Down arrow
          selectedMenuIndex = Math.min(
            totalNumberofMenu,
            selectedMenuIndex + 1
          );
          forceUpdate();
          // setState({ rerender: !rerender });
          break;
        case 13: // Enter
          if (currentScreen === menuItems[selectedMenuIndex - 1].menuName) {
            handleMenuselection(menuItems[selectedMenuIndex - 1].menuName);
            // return;
          } else {
            //prevSelectedMenuIndex = selectedMenuIndex;
            currentScreen = menuItems[selectedMenuIndex - 1].menuName;
            // console.log(currentScreen);
            // window.removeEventListener("keydown", handleKeyDown);
            if (menuItems[selectedMenuIndex - 1].menuName === "Logout") {
              //currentScreen = "Home";
              //selectedMenuIndex = 4;
              //currentScreen = menuItems[selectedMenuIndex - 1].name;
              //prevSelectedMenuIndex = selectedMenuIndex - 1;
              handleLogout(menuItems[selectedMenuIndex - 1].menuName);
              //appNavigate("LanguagePage");
            } else if (
              menuItems[selectedMenuIndex - 1].menuName === "Watchlist"
            ) {
              currentScreen = menuItems[selectedMenuIndex - 1].menuName;
              localStorage.setItem("WatchList", true);
              prevSelectedMenuIndex = selectedMenuIndex;
              if (isLogedIn) appNavigate("WatchlistScreen");
              else handleLogin(menuItems[selectedMenuIndex - 1].menuName);
            } else if (menuItems[selectedMenuIndex - 1].menuName === "Login") {
              //currentScreen = "Home";
              //selectedMenuIndex = 4;
              //currentScreen = menuItems[selectedMenuIndex - 1].name;
              //prevSelectedMenuIndex = selectedMenuIndex - 1;
              handleLogin(menuItems[selectedMenuIndex - 1].menuName);
              //appNavigate("LanguagePage");
            } else {
              console.log("5555555555.....");
              currentScreen = menuItems[selectedMenuIndex - 1].menuName;
              prevSelectedMenuIndex = selectedMenuIndex;
              console.log(currentScreen, prevSelectedMenuIndex);
              handleMenuselection(menuItems[selectedMenuIndex - 1].menuName);
            }
          }
          break;
        case 39:
          if (prevSelectedMenuIndex !== selectedMenuIndex) {
            selectedMenuIndex = prevSelectedMenuIndex;
          }
          handleRightButton();
          break;
        case 8:
          if (!menustate) {
            window.removeEventListener("keydown", handleKeyDown);
            setZindx((prevState) => ({
              zindx: 0,
            }));
            handleExit();
          }
          break;
        case 10009:
          if (!menustate) {
            window.removeEventListener("keydown", handleKeyDown);
            setZindx((prevState) => ({
              zindx: 0,
            }));
            handleExit();
          }
          break;
        case 461:
          if (!menustate) {
            window.removeEventListener("keydown", handleKeyDown);
            setZindx((prevState) => ({
              zindx: 0,
            }));
            handleExit();
          }
          break;
        default:
          break;
      }
    }
  };
  addFocus = (focus) => {
    setMenuState(focus);
  };
  SetFocusTodefault = (mindx) => {
    if (mindx >= 0) {
      currentScreen = "Home";
      prevSelectedMenuIndex = mindx;
      selectedMenuIndex = mindx;
      forceUpdate();
      // setState({ rerender: !rerender });
    } else {
      selectedMenuIndex = prevSelectedMenuIndex;
      forceUpdate();
      // setState({ rerender: !rerender });
    }
  };

  function debounceMultiple(funcs, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        funcs.forEach((fn) => fn(...args));
      }, delay);
    };
  }

  const debouncedHandleKeyDown = debounceMultiple([handleKeyDown],10)

  useEffect(() => {
    //   console.log("Menuscreen useEffect shouldCloseMenu ------ = ",shouldCloseMenu)
    if (isLogedIn) {
      totalNumberofMenu = 9;
    } else {
      totalNumberofMenu = 8;
    }
    // if(isLogedIn){totalNumberofMenu = 7}else{totalNumberofMenu = 6;}
    if (!menustate) {
      //window.addEventListener('keydown', handleKeyDown);
      setTimeout(function () {
        window.addEventListener("keydown", debouncedHandleKeyDown);
      }, 500);
    }
    return () => {
      window.removeEventListener("keydown", debouncedHandleKeyDown);
    };
  }, [menustate]);

  useEffect(() => {
    // Change the background color of all selected icons
    const iconNames = [
      isLogedIn ? "logedInUser_selected" : "user_selected",
      "search_selected",
      "live_selected",
      "home_selected",
      "watchlist_selected",
      "categories_selected",
      "settings_selected",
      "logout_selected",
    ];
    iconNames.forEach((iconName) => {
      changeImageBgColor(images[iconName], 255, 103, 31, (newImgSrc) => {
        setImages((prev) => ({ ...prev, [iconName]: newImgSrc }));
      });
    });
  }, []);

  const styles = {
    menuScreenContainer: {
      // background: `url(${side_menu})`,
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      height: "100vh",
      width: resolution === "FHD" ? "83px" : "61px",
      // backgroundColor: "#000000",
      position: "relative",

      left: "0px",
      zIndex: zindx,
    },
    iconContainer: {
      // background: `url(${side_menu})`,
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      height: "100vh",
      width: resolution === "FHD" ? "78px" : "48px",
      position: "absolute",
      left: "0px",
    },
    textContainer: {
      background: `url(${side_menu})`,
      display: menustate ? "none" : "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      height: "100vh",
      width: resolution === "FHD" ? "100vw" : "100vw",
      // width: resolution === "FHD" ? "195px" : "135px",
      position: "absolute",
      left: resolution === "FHD" ? "78px" : "51px",
      color: "#FFFFFF",
      backgroundColor: "#000000",
      fontSize: resolution === "FHD" ? "26px" : "17px",
      opacity: 0.9,
    },
    menuItem: (isActive, marginTop) => ({
      borderLeft: isActive ? "5px solid #EC008C" : "5px solid transparent",
      position: "absolute",
      marginTop,
      height: resolution === "FHD" ? "80px" : "42px",
      width: resolution === "FHD" ? "78px" : "52px",
      backgroundColor: isActive ? "#FFFFFF33" : "transparent",
      borderRadius: "7.5px",
      borderTopRightRadius: "0px", // No rounding on top-right corner
      borderBottomRightRadius: "0px", // No rounding on bottom-right corner
    }),
    icon: {
      position: "absolute",
      objectFit: "cover",
      width: resolution === "FHD" ? "33px" : "22px",
      // height: resolution === "FHD" ? "33px" : "22px",
      marginTop: resolution === "FHD" ? "27px" : "22px",
      marginLeft: resolution === "FHD" ? "20px" : "13px",
      // borderWidth: resolution === "FHD" ? "2px" : "1px",  // Set appropriate border width
      // borderStyle: "solid",  // Add solid border style
      // borderColor: "#000000"
    },
    menuText: (marginTop, isActive) => ({
      position: "absolute",
      width: resolution === "FHD" ? "250px" : "127px",
      height: resolution === "FHD" ? "80px" : "42px",
      marginLeft: "0px",
      marginTop,
      backgroundColor: isActive ? "#FFFFFF33" : "transparent",
      borderRadius: "7.5px",
      borderTopLeftRadius: "0px", // No rounding on top-right corner
      borderBottomLeftRadius: "0px", // No rounding on bottom-right corner
      display: "flex",
      alignItems: "center",
      paddingLeft: "10px",
    }),
  };

  const handleItemClick = (item) => {
      selectedMenuIndex = item.id;
      if (currentScreen === item.menuName) {
        handleMenuselection(item.menuName);
      } else {
        currentScreen = item.menuName;
        if (item.menuName === "Logout") {
          handleLogout(item.menuName);
        } else if (item.menuName === "Watchlist") {
          currentScreen = item.menuName;
          localStorage.setItem("WatchList", true);
          prevSelectedMenuIndex = selectedMenuIndex;
          if (isLogedIn) appNavigate("WatchlistScreen");
          else handleLogin(item.menuName);
        } else if (item.menuName === "Login") {
          handleLogin(item.menuName);
        } else {
          currentScreen = item.menuName;
          prevSelectedMenuIndex = selectedMenuIndex;
          handleMenuselection(item.menuName);
        }
      }
  };

  return (
    <div
      style={{
        ...styles.menuScreenContainer,
      }}
      onMouseLeave={() => {
        selectedMenuIndex = prevSelectedMenuIndex;
        forceUpdate();
      }}
    >
      <div style={{ ...styles.iconContainer }}>
        <div
          style={styles.menuItem(false, resolution === "FHD" ? "5px" : "3px")}
        >
          <img
            src={menulogo}
           style={{
              position: "absolute",
              width: menustate && resolution === "FHD" ? "4rem" : "4rem",
              height: menustate && resolution === "FHD" ? "5rem" : "5rem",
              marginTop: menustate && resolution === "FHD" ? "3rem" : "3rem",
              marginLeft:
                menustate && resolution === "FHD" ? "1.1rem" : "1.1rem",
              zIndex: menustate ? 1 : 1,
              objectFit: "cover",

              // right: resolution === "FHD" ? "20px" : "17px",
            }}
          />
        </div>
        {menuItems?.map((item) => {         
          const isActive = selectedMenuIndex === item.id || hoveredItemId === item.id;
          return (
          <Wrapper
            key={item.id || Date.now()}
            style={{
              ...styles.menuItem(
                // selectedMenuIndex === item.id,
                isActive,
                resolution === "FHD"
                  ? `${185 + (item.id - 1) * 93}px`
                  : `${123 + (item.id - 1) * 62}px`
              ),
            }}
            onMouseEnter={() => {
                  selectedMenuIndex = item.id;
                  forceUpdate();
              }}
            onMouseLeave={() => setHoveredItemId(null)}
            onClick={() => handleItemClick(item)}
          >
            <img
              src={
                selectedMenuIndex === item.id || prevSelectedMenuIndex === item.id ? item.selectedIcon : item.icon
              }
              style={styles.icon}
            />
          </Wrapper>
        )})}
      </div>
      <div
        style={{
          ...styles.textContainer,
        }}
      >
        {menuItems?.map((item) => {
          const isActive = selectedMenuIndex === item.id || hoveredItemId === item.id;
          return (
            <Wrapper
            key={item.id || Date.now()}
            style={styles.menuText(
              resolution === "FHD"
                ? `${185 + (item.id - 1) * 93}px`
                : `${123 + (item.id - 1) * 62}px`,
              // selectedMenuIndex === item.id,
              isActive,
            )}
            onMouseEnter={() => {
                  selectedMenuIndex = item.id;
                  forceUpdate();
              }}
            onMouseLeave={() => setHoveredItemId(null)}
            onClick={() => handleItemClick(item)}
          >
            {item.name}
          </Wrapper>
          )  
        })}
      </div>
    </div>
  );
};

MenuScreen.SetFocus = (focus) => {
  addFocus(focus);
};

MenuScreen.ReseTfocus = (menuIndx) => {
  SetFocusTodefault(menuIndx);
};

export default MenuScreen;